import { render, staticRenderFns } from "./PageAllow.vue?vue&type=template&id=50c2891b"
import script from "./PageAllow.vue?vue&type=script&lang=js"
export * from "./PageAllow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports